"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpSearchDropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var react_i18next_1 = require("react-i18next");
var DpSearchDropdown_styled_1 = require("./DpSearchDropdown.styled");
var api_1 = require("../../../api");
var atomic_ui_lib_lts_1 = require("@greatmindsorg/atomic-ui-lib-lts");
var Spinner_1 = require("../Spinner/Spinner");
var DpSearchDropdown = function (_a) {
    var selectionHandler = _a.selectionHandler, optionList = _a.optionList, placeholder = _a.placeholder, fetchOptions = _a.fetchOptions, _b = _a.disabled, disabled = _b === void 0 ? false : _b, focusHandler = _a.focusHandler, _c = _a.id, id = _c === void 0 ? 'default' : _c, _d = _a.optionsLoading, optionsLoading = _d === void 0 ? false : _d;
    // ------------------ State
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var ref = (0, react_1.useRef)();
    var _e = (0, react_1.useState)(false), isOpen = _e[0], setOpen = _e[1];
    var _f = (0, react_1.useState)(''), value = _f[0], setValue = _f[1];
    var _g = (0, react_1.useState)(optionList), options = _g[0], setOptions = _g[1];
    var _h = (0, react_1.useState)(false), isLoading = _h[0], setIsLoading = _h[1];
    var _j = (0, api_1.useRoveFocus)(options === null || options === void 0 ? void 0 : options.length, ref), focusIndex = _j[0], setFocusIndex = _j[1];
    var loading = isLoading || optionsLoading;
    // ------------------ Methods
    var toggle = function () { return setOpen(!isOpen); };
    var selectItem = function (option) {
        var _value = option.name.replace(/(<([^>]+)>)/gi, '');
        setValue(_value);
        toggle();
        selectionHandler(option);
    };
    var createListItems = function () {
        var list = [];
        var counter = 0;
        if (options) {
            var orderedOptions = options.sort(function (firstOption, secondOption) {
                return firstOption.name.localeCompare(secondOption.name);
            });
            orderedOptions.forEach(function (option) {
                var _value = option.name.replace(/(<([^>]+)>)/gi, '');
                var handler = function (e) {
                    selectItem(option);
                    setOpen(false);
                    if (typeof focusHandler === 'function')
                        focusHandler();
                };
                list.push((0, jsx_runtime_1.jsx)("li", { "data-value": option.id, onClick: function () { return selectItem(option); }, "data-index": counter, tabIndex: -1, "aria-selected": _value === value, role: "option", onKeyDown: (0, api_1.handleButtonPress)(handler), children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: option.name } }) }, option.id));
                counter++;
            });
        }
        return list;
    };
    var handleKeyUp = function (e) {
        selectionHandler(null);
        if (e.key === 'Enter' || e.key === 'ArrowDown') {
            toggle();
            var actualValue = options.find(function (_a) {
                var name = _a.name;
                return name.toUpperCase() === value.toUpperCase();
            });
            if (!(0, isUndefined_1.default)(actualValue)) {
                selectionHandler(actualValue);
            }
        }
    };
    var filter = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var filteredList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(value.length >= 3 || value.length === 0)) return [3 /*break*/, 4];
                    if (!fetchOptions) return [3 /*break*/, 2];
                    setIsLoading(true);
                    return [4 /*yield*/, fetchOptions(value)];
                case 1:
                    filteredList = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    filteredList = optionList.filter(function (_a) {
                        var name = _a.name;
                        return name.toUpperCase().indexOf(value.toUpperCase()) > -1;
                    });
                    _a.label = 3;
                case 3:
                    setOptions(filteredList);
                    setIsLoading(false);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [optionList, value, fetchOptions]);
    var handleChange = function (e) {
        var newValue = e.target.value;
        setValue(newValue);
        newValue.length >= 3 && setOpen(true);
    };
    var handleClick = function () {
        toggle();
        if (typeof focusHandler === 'function')
            focusHandler();
    };
    (0, react_1.useEffect)(function () {
        filter();
    }, [filter]);
    (0, react_1.useEffect)(function () {
        setValue('');
    }, [optionList]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector("[data-index=\"".concat(focusIndex, "\"]"))) === null || _b === void 0 ? void 0 : _b.focus();
    }, [focusIndex]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector("[data-index='0']")) === null || _b === void 0 ? void 0 : _b.focus();
        if (isOpen)
            setFocusIndex(0);
    }, [isOpen, setFocusIndex]);
    // ------------------ Render
    return ((0, jsx_runtime_1.jsxs)(DpSearchDropdown_styled_1.StyledSearchDropdown, { className: "search-dropdown", value: value, open: isOpen, children: [(0, jsx_runtime_1.jsx)("input", { value: value, onClick: handleClick, onChange: handleChange, onKeyUp: handleKeyUp, placeholder: placeholder, "aria-label": placeholder, disabled: disabled, id: "search-dropdown-".concat(id) }), loading && ((0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { className: "spinner override-color", size: atomic_ui_lib_lts_1.SpinnerSize.small, ariaLabel: t('DpSearchDropdown.fetchingInformation') })), (0, jsx_runtime_1.jsx)("ul", { ref: ref, role: "listbox", "aria-labelledby": "search-dropdown-".concat(id), tabIndex: 0, className: loading ? 'd-none' : '', children: createListItems() })] }));
};
exports.DpSearchDropdown = DpSearchDropdown;
exports.default = exports.DpSearchDropdown;
